import MyTabs from '../../components/MyTabs';
import Section1 from './FlipBook';

const GeneralFlipBooks = () => {

    const tabs = [
        { id: "Basic", title: "Basic Flip Book Info", Component: Section1 },
    ];

    return (
        <MyTabs list={tabs} />
    )
};

export default GeneralFlipBooks;